// extracted by mini-css-extract-plugin
module.exports = {"contactLinks":"styles_contactLinks__UTb_n","telNumber":"styles_telNumber__ovgof","link":"styles_link__e4WTp"};